/**
 * Falsch-Antworten-Deck. Speichert Quiz-Fehler als Karteikarten in localStorage.
 * So kann man gezielt die eigenen Schwächen nochmal üben.
 */

const LS_KEY = "error_deck_v1";

export interface ErrorCard {
  topicId: string;
  question: string;
  answer: string;   // Musterlösung / Erklärung aus dem Feedback
  addedAt: number;
}

function load(): ErrorCard[] {
  try {
    const raw = localStorage.getItem(LS_KEY);
    return raw ? (JSON.parse(raw) as ErrorCard[]) : [];
  } catch { return []; }
}

function save(cards: ErrorCard[]): void {
  try { localStorage.setItem(LS_KEY, JSON.stringify(cards)); } catch { /* ignore */ }
}

export function addErrorCard(topicId: string, question: string, feedback: string): void {
  const cards = load();
  // Duplikat-Schutz: gleiche Frage für gleiches Thema nicht doppelt
  if (cards.some((c) => c.topicId === topicId && c.question === question)) return;
  cards.push({ topicId, question, answer: feedback, addedAt: Date.now() });
  // Max 200 Karten behalten (älteste raus)
  if (cards.length > 200) cards.splice(0, cards.length - 200);
  save(cards);
}

export function removeErrorCard(topicId: string, question: string): void {
  save(load().filter((c) => !(c.topicId === topicId && c.question === question)));
}

export function getErrorCards(topicId?: string): ErrorCard[] {
  const all = load();
  return topicId ? all.filter((c) => c.topicId === topicId) : all;
}

export function clearErrorCards(topicId: string): void {
  save(load().filter((c) => c.topicId !== topicId));
}

export function errorCardCount(topicId?: string): number {
  return getErrorCards(topicId).length;
}
